import { render, staticRenderFns } from "./add-category.vue?vue&type=template&id=30c76496"
import script from "./add-category.vue?vue&type=script&lang=js"
export * from "./add-category.vue?vue&type=script&lang=js"
import style0 from "./add-category.vue?vue&type=style&index=0&id=30c76496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports